// react
import React, { useState, useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import Select from 'react-select';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
// services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatoriosPersonalizadosList() {
  const { t } = useTranslation();

  const session = useContext(SessionContext);
  const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });
  const classes = useStyles();

  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification(prev => ({ ...prev, show: false }));
    }, 6000);
  };

  const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
  const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

  const monthDiff = (dateFrom, dateTo) => {
    return dateTo.getMonth() - dateFrom.getMonth() +
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }
  useEffect(() => {
    LoadCaminhoVirtual();
  }, []);
   //busca o path virtual do sistema para fazer o download de arquivo
   const [caminhoVirtual, setcaminhoVirtual] = React.useState("");
   const LoadCaminhoVirtual = () => {
     let endpointPath = "setupsistema/bycaminhovirtual"
     UseGetApiSimple(endpointPath, 0).then(result => {
       if (result.status !== 200) {
         showNotification(result.message, 'danger');
         return false;
       }
       setcaminhoVirtual(result.data);
     });
   }

  const handleClickPesquisa = () => {

    setlistRelatotrios([]);
    let data = getValues();

    if (data.dtini === "") {
      setError("dtini", "required", t('label.required'))
      return false;
    }
    else
      clearError("dtini")

    if (data.dtfim === "") {
      setError("dtfim", "required", t('label.required'))
      return false;
    }
    else
      clearError("dtfim")

    if (!validateDate(data.dtini)) {
      setError("dtini", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
    else
      clearError("dtini")

    if (!validateDate(data.dtfim)) {
      setError("dtfim", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
    else
      clearError("dtfim")

    var dataIniConvertida = convertDate(data.dtini);
    var dataFimConvertida = convertDate(data.dtfim);

    let obj = {
      dataIni: dataIniConvertida,
      dataFim: dataFimConvertida,
      estabelecimentoId: session.estabelecimentoId
    }
    loadRelatorios(obj);
  };

  const [isLoadingList, setisLoadingList] = React.useState(false);
  const [listRelatotrios, setlistRelatotrios] = React.useState([]);
  const [relatorioSelected, setrelatorioSelected] = React.useState(null);
  const loadRelatorios = (obj) => {
    setlistRelatotrios([]);
    setisLoadingList(true);
    const endPoint = "relatoriosPersonalizados/byestabelecimento";
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setisLoadingList(false);
        return false;
      }
      if(result.data.length > 0){
        setlistRelatotrios(result.data);
        setisLoadingList(false);
        return true;
      }
      else{
        showNotification("Não há relatórios disponíveis neste período para seu estabelecimento!", 'info')
        setisLoadingList(false);
        return false;
      }

    });
  }
  const handleRelatorioChange = event => {
    let value = event
    setrelatorioSelected(value);
    setValue("relatoriosPersonalizado", value);
    if (value !== "")
      clearError("relatoriosPersonalizado");
  }

  const handleBaixarRelatorio = () => {
    window.open(caminhoVirtual + relatorioSelected.caminhoArquivo, "_blank");

  }

  return (
    <div>

      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
        close
      />
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t('register.list_custom_reports')}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth className={classes.formControl}>
                    <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                      {t('label.ini_date') + " *"}  </label>
                    <Datetime
                      locale={getLocale()}
                      dateFormat={getStringFormatDate()}
                      timeFormat={false}
                      name="dtini"
                      defaultValue={dtini}
                      value={dtini}
                      onChange={date => { setdtini(date) }}
                      inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                      className={errors.dtini ? "error" : ""}
                    />
                    {errors.dtini && <FormHelperText className={classes.labelRootError}>
                      <span> {errors.dtini.message} </span>
                    </FormHelperText>}
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth className={classes.formControl}>
                    <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                      {t('label.end_date') + " *"}  </label>
                    <Datetime
                      locale={getLocale()}
                      dateFormat={getStringFormatDate()}
                      timeFormat={false}
                      name="dtfim"
                      defaultValue={dtfim}
                      value={dtfim}
                      onChange={date => { setdtfim(date) }}
                      inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                      className={errors.dtfim ? "error" : ""}
                    />
                    {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                      <span> {errors.dtfim.message} </span>
                    </FormHelperText>}
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={2}>
                  <Button round color="primary"
                    onClick={e => { handleClickPesquisa() }}>
                    {t('label.search')}
                  </Button>
                </GridItem>
              </GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <br></br>
                <div className="subTitulo">
                  <h6>{t('label.available_reports')} </h6>
                </div>
              </GridItem>
              {listRelatotrios.length > 0 &&
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <FormControl fullWidth className={classes.formControl}>
                      <Select
                        fullWidth
                        size="small"
                        error={errors.relatoriosPersonalizado ? true : false}
                        variant="outlined"
                        inputRef={register({ required: t('label.required') })}
                        isSearchable={true}
                        isLoading={isLoadingList}
                        name="relatoriosPersonalizado"
                        placeholder="Selecione..."
                        options={listRelatotrios}
                        value={relatorioSelected != null && listRelatotrios.filter(({ relatorioPersonalizado_Id }) => relatorioPersonalizado_Id === relatorioSelected.relatorioPersonalizado_Id)}
                        getOptionLabel={({ nomeRelatorio }) => nomeRelatorio}
                        getOptionValue={({ relatorioPersonalizado_Id }) => relatorioPersonalizado_Id}
                        onChange={(value) => handleRelatorioChange(value)}
                        ref={() => register({ name: "relatoriosPersonalizado" })
                        }
                      />
                      {errors.relatorioPersonalizado &&
                        <FormHelperText>
                          <span className="obg"> {t('label.select_an_report')} </span>
                        </FormHelperText>}
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={2}>
                    <Button round color="primary"
                      onClick={e => { handleBaixarRelatorio() }}>
                      {t('button.download_report')}
                    </Button>
                  </GridItem>
                </GridContainer>}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

    </div>
  );
}
